import { Component, Element, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'pnk-radio-group',
  styleUrl: 'pnk-radio-group.css',
})
export class PnkRadioGroup {
  @Element() host!: HTMLElement;

  @State() radios: Array<HTMLPnkRadioButtonElement> = [];

  randomName: string = `${Math.floor(Math.random() * 1000)}`;

  @Prop() name: string = `radio-group-${this.randomName}`;

  @Prop({ mutable: true, reflect: true }) value: string | undefined = undefined;

  componentWillLoad() {
    this.setupRadios();
  }

  setupRadios() {
    this.radios = Array.from(this.host.children).filter(element => element.tagName === 'PNK-RADIO-BUTTON') as HTMLPnkRadioButtonElement[];
    this.radios.forEach((radio: HTMLPnkRadioButtonElement) => {
      radio.name = this.name;
      radio.checked = radio.value === this.value;
      radio.addEventListener('change', this.handleChange.bind(this));
    });
  }

  handleChange(event: Event) {
    const selectedRadio = event.target as HTMLPnkRadioButtonElement;
    if (selectedRadio.checked && selectedRadio.value !== this.value) {
      const previousRadio = this.radios.find(radio => radio.value === this.value);
      if (previousRadio && !previousRadio.disabled) {
        previousRadio.checked = false;
      }
      this.value = selectedRadio.value;
      console.log('New value:', this.value);
      const changeEvent = new CustomEvent('change', {
        detail: this.value,
        bubbles: true,
        composed: true,
      });
      this.host.dispatchEvent(changeEvent);
    }
  }

  render() {
    return <slot onSlotchange={() => this.setupRadios()}></slot>;
  }
}
